import React, { useContext, useState,useEffect } from 'react'
import { DistanceMatrixService, useJsApiLoader } from '@react-google-maps/api';
import { SiteContext } from '../../context/siteContext'
import { FilterContext } from '../../context/filterContext'
import axios from 'axios'
import styles from './category.module.css'
import { FaSearchLocation,FaSearch } from 'react-icons/fa'
import {BsSearch} from 'react-icons/bs'
import TubbeesLogo from '../../images/Tubbees.png'
import Vaped4ULogo from '../../images/VAPED4U.png'
import RaceTrackLogo from '../../images/RaceTrack.png'
import HoagiesLogo from '../../images/Hoagies.png'

export default function Distance(props) {

    const { markers, setMarkers } = useContext(SiteContext);
    const [postcode, setPostcode] = useState('')
    const [dataPoints, setDataPoints] = useState([])
    const [sites, setSites] = useState([])
    const [message, setMessage] = useState([])
    const [showMessage, setShowMessage] = useState(false)
    const [checkDistance, setCheckDistance] = useState(false)
    const [showClearBtn, setShowClearBtn] = useState(false)
    const { filterData } = useContext(FilterContext);
    const [logo,setLogo]=useState('')

    useEffect(()=>{
        switch (props.brand) {
            case "Tubbees":
                setLogo(TubbeesLogo)
                break;
            case "RaceTrack":
                setLogo(RaceTrackLogo)
                break;
            case "Vaped4U":
                setLogo(Vaped4ULogo)
                break;
            case "Hoagies":
                setLogo(HoagiesLogo)
                break;
            default:
                setLogo(TubbeesLogo)
        }
    },[props.brand])

    const viewDistance = async (point) => {
        var data = markers;
        try {
            for (let i = 0; i < data.length; i++) {
                data[i].Distance = point.rows[0].elements[i].distance
            }
            const sortData = data.sort(compare);
            const a = markers.filter(site => site.name === sortData[0].name)
            setMarkers(a)
            setCheckDistance(false)
            setMessage(`Your Nearest Store is ${sortData[0].name}`)
            setShowMessage(true)
            setTimeout(() => {
                // setShowMessage(false)
                setShowClearBtn(true)
            }, 1500)
        } catch (err) {
            console.log(err)
        }
    }

    function compare(a, b) {
        if (a.Distance.value < b.Distance.value) {
            return -1;
        }
        if (a.Distance.value > b.Distance.value) {
            return 1;
        }
        return 0;
    }

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyCA17XufYl3oox1qRT6aXvvM8JqmyvGC1I"
    });

    const submit = (event) => {
        if (event.key === "Enter") {
            checkPostcode();

        }
    }

    const checkPostcode = async () => {
        var data = { postcode: postcode }
        await axios.post("https://maps.rt-itservices.co.uk/postcode", data).then((res) => {
            if (!res.data.Found) {
                setMessage("Postcode Not Found")
                setShowMessage(true)
                setTimeout(() => {
                    setPostcode("")
                    setShowMessage(false)
                }, 2000)
            } else {
                setDataPoints(res.data.points)
                sitePoints();
                setCheckDistance(true)
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    function sitePoints() {
        var data = [];
        for (let i = 0; i < markers.length; i++) {
            data.push({ lat: markers[i].Address.latitude, lng: markers[i].Address.longitude })
        }
        setSites(data)
    }

    const reset = async () => {
        setPostcode("")
        // await axios.get("http://localhost:5000/").then((res) => {
        //     setMarkers(res.data)
        //     setShowMessage(false)
        //     setShowClearBtn(false)
        // }).catch((err) => {
        //     console.log(err)
        // })
            setMarkers(filterData)
            setShowMessage(false)
            setShowClearBtn(false)
    }
    const searchReset=()=>{
        // axios.get("http://localhost:5000/").then((res) => {
        //     setMarkers(res.data)
        // }).catch((err) => {
        //     console.log(err)
        // })
        setMarkers(filterData)
    }

    return isLoaded ? (
        <>
            <div className="input-group abc">
                <input className={`form-control ${styles.input}`} type="text" placeholder="Enter Postcode..." onChange={(e) => { setPostcode(e.target.value) }} onKeyDown={submit} value={postcode} onFocus={searchReset}/>
                <span className="input-group-btn">
                <button className={`btn p-2 ${styles.input} ${styles.search}`} onClick={checkPostcode}><BsSearch/></button>
                </span>
                <br />
            </div>
            {showMessage ? <><hr /><p className={`${styles.message}`}>{message}</p></> : props.big?<span className={`${styles.logobox}`}><img className={`${styles.logo}`} src={logo} alt="Tubbees Logo"/></span>:<></>}
            {showClearBtn ? <><hr /><button className="btn btn-danger w-100" onClick={reset}>Clear</button></> : <></>}
            {checkDistance ?
                <DistanceMatrixService
                    options={{
                        destinations: sites,
                        origins: [dataPoints],
                        travelMode: "DRIVING",
                    }}
                    callback={(response) => { viewDistance(response) }}
                />
                : <></>}
        </>
    ) : <></>
}
